/** @typedef {import('../../shared/OfferService/OffersProps').default} Props */

import { translate } from '../../Internationalization';
import AgentVendors from './Vendors/AgentVendors';
import FormSuccessMessages from '../../../shared/Forms/Messages/FormSuccessMessages';
import flags from '../../../shared/Flags';
import images from '../../../config/local/images';
import LinkButton from '../../../shared/LinkButton';
import paths from '../../../config/local/paths';
import React from 'react';
import useGetAgentVendors from '../../../Hooks/Agent/Getters/useGetAgentVendors/useGetAgentVendors';
import useIsGated from '../../../Hooks/Shared/useIsGated/useIsGated';
import VendorExclusivity from '../../shared/VendorExclusivity';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function ViewVendors(props) {
	const { isGated } = useIsGated(flags.vendor.add);
	const { total } = useGetAgentVendors('all', 1, isGated);

	return (
		<React.Fragment>
			<header className="mt-10 mb-6 md:flex justify-between items-center">
				<h1 className="hl-ms-6 mb-6 md:mb-0">
					{`${translate('agent.pages.offers.view.title')}`}{' '}
					{total ? `(${total})` : ''}
				</h1>

				{!isGated ? (
					<LinkButton
						icon={images.icons.plus}
						to={paths.app.agent.offers.add}
					>
						{translate('global.offers.add_title')}
					</LinkButton>
				) : null}
			</header>

			<FormSuccessMessages messages={props.location?.state?.message} />

			{/* @ts-ignore type error with services-container */}
			<VendorExclusivity type="agent" />

			<AgentVendors />
		</React.Fragment>
	);
}
